// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dxey6{display:flex}.n_45n{margin-bottom:8px}.OIJoY{height:32px;width:32px;padding:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inlineMenu": `Dxey6`,
	"advancedTitle": `n_45n`,
	"ellipsisMenu": `OIJoY`
};
export default ___CSS_LOADER_EXPORT___;
